import { BASE_URL } from '@lib/constants';

export default async function getAdvisorNotes(token, prospectus_id) {
	const response = await fetch(`${BASE_URL}/wp-json/edu_api/advisor/notes/get`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			prospectus_id: prospectus_id,
		}),
	});

	const responseData = await response.json();

	return responseData;
}
